import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const MODULE_WEBHOOKS_TABLE_STORAGE_KEY = "moduleWebhooksTableStorageKey";
export const MODULE_WEBHOOKS_TABLE_FILTERS_STORAGE_KEY = "moduleWebhooksTableFiltersStorageKey";

export enum MODULE_WEBHOOKS_COLUMN_ID {
  ENDPOINT = "ENDPOINT",
  STATUS = "STATUS",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 1200;

export const MODULE_WEBHOOKS_TABLE_COLUMNS_CONFIG: Record<
  MODULE_WEBHOOKS_COLUMN_ID,
  TableColumnMeta
> = {
  [MODULE_WEBHOOKS_COLUMN_ID.ENDPOINT]: {
    id: MODULE_WEBHOOKS_COLUMN_ID.ENDPOINT,
    title: "Endpoint",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_WEBHOOKS_COLUMN_ID.STATUS]: {
    id: MODULE_WEBHOOKS_COLUMN_ID.STATUS,
    title: "Enabled",
    minWidth: 112,
    defaultWidth: 140,
    maxWidth: 200,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT]: {
    id: MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [MODULE_WEBHOOKS_COLUMN_ID.DROPDOWN]: {
    id: MODULE_WEBHOOKS_COLUMN_ID.DROPDOWN,
    title: "Webhook actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};

export const SORT_CONFIG = {
  [MODULE_WEBHOOKS_COLUMN_ID.ENDPOINT]: "endpoint",
  [MODULE_WEBHOOKS_COLUMN_ID.STATUS]: "enabled",
  [MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT]: "createdAt",
};

export const INITIAL_SORT_OPTION = SORT_CONFIG[MODULE_WEBHOOKS_COLUMN_ID.CREATED_AT];
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
